import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {UserDataForm} from '../../types/userData'
import SingleModelInterface, {Promotion} from '../../types/singleModelInterface'

export const userDataSlice = createSlice({
    name: 'userData',
    initialState: {
        personalData: {} as UserDataForm,
        thanksPage: false,
        selectedFormModel: null,
        formCycleID: '',
        autoloadedRFQForm: false,
        // Promotion whose conditions and legal notes are shown inside the
        // form, set when landing with `promo-app` in the URL.
        formPromotion: null as Promotion | null,
    },
    reducers: {
        showThanksPage(
            state: RootState,
            action: PayloadAction<boolean | undefined>
        ): void {
            state.thanksPage = action.payload
        },
        setPersonalData(
            state: RootState,
            action: PayloadAction<Record<string, never> | UserDataForm>
        ): void {
            state.personalData = action.payload
        },
        setSelectedFormModel(
            state: RootState,
            action: PayloadAction<SingleModelInterface>
        ): void {
            state.selectedFormModel = action.payload
        },
        setFormCycleID(state: RootState, action: PayloadAction<string>): void {
            state.formCycleID = action.payload
        },
        setAutoloadedRFQForm(
            state: RootState,
            action: PayloadAction<boolean>
        ): void {
            state.autoloadedRFQForm = action.payload
        },
        setFormPromotion(
            state: RootState,
            action: PayloadAction<Promotion | null>
        ): void {
            state.formPromotion = action.payload
        },
    },
})

export const {
    setPersonalData,
    showThanksPage,
    setSelectedFormModel,
    setFormCycleID,
    setAutoloadedRFQForm,
    setFormPromotion,
} = userDataSlice.actions
export default userDataSlice.reducer
